/**
 * European Way — Stage Router (in-page product filter + mobile sticky bar)
 * assets/ew-stage-router.js
 *
 * Behaviour:
 *   - The four stage buttons act as an in-page tag filter. Clicking one shows only
 *     the products in the source collection whose tags contain that stage tag
 *     (e.g. "stage-1"). No reload, no navigation.
 *   - The server pre-filters to the first stage on load; this script keeps the
 *     active-button state and the visible products in sync from there.
 *   - On mobile, a slim fixed bottom bar mirrors the same filter buttons and appears
 *     once the visitor scrolls the hero out of view. Tapping a sticky button filters
 *     and scrolls the grid into view.
 *
 * No build step, no external deps. Exposed on window.ewStageRouter.
 */

window.ewStageRouter = window.ewStageRouter || {};

window.ewStageRouter.init = function () {
  'use strict';

  var roots = document.querySelectorAll('.shopify-section--ew-stage-router');
  for (var i = 0; i < roots.length; i++) {
    initSection(roots[i]);
  }

  function initSection(root) {
    var grid = root.querySelector('[data-ew-product-grid]');
    var products = grid
      ? Array.prototype.slice.call(grid.querySelectorAll('[data-ew-product]'))
      : [];
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ew-stage]'));
    var emptyMsg = root.querySelector('[data-ew-empty]');

    // ── Filtering ───────────────────────────────────────────────────────────
    function applyFilter(tag, scrollToGrid) {
      // Sync active state on every button sharing this tag (main row + sticky bar)
      for (var b = 0; b < buttons.length; b++) {
        var isActive = buttons[b].getAttribute('data-ew-stage') === tag;
        buttons[b].classList.toggle('is-active', isActive);
        buttons[b].setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }

      if (products.length) {
        var needle = ',' + tag + ',';
        var visible = 0;
        for (var p = 0; p < products.length; p++) {
          var tags = products[p].getAttribute('data-ew-tags') || '';
          var match = !tag || tags.indexOf(needle) > -1;
          products[p].classList.toggle('ew-is-hidden', !match);
          if (match) { visible++; }
        }
        if (emptyMsg) { emptyMsg.hidden = visible !== 0; }
      }

      if (scrollToGrid && grid && typeof grid.scrollIntoView === 'function') {
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    for (var k = 0; k < buttons.length; k++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var tag = btn.getAttribute('data-ew-stage');
          var fromSticky = !!btn.closest('[data-ew-sticky-router]');
          applyFilter(tag, fromSticky);
        });
      })(buttons[k]);
    }

    // Sync initial state to the first button (server already rendered its products)
    if (buttons.length) {
      applyFilter(buttons[0].getAttribute('data-ew-stage'), false);
    }

    // ── Mobile sticky bar visibility ──────────────────────────────────────────
    var stickyBar = root.querySelector('[data-ew-sticky-router]');
    if (!stickyBar) { return; }

    var mobileQuery = window.matchMedia('(max-width: 480px)');
    function isMobile() { return mobileQuery.matches; }

    var hero = document.querySelector('.ew-manifesto-hero') ||
               document.querySelector('.ew-section');

    function showSticky() {
      if (!isMobile()) { return; }
      stickyBar.classList.add('is-visible');
      stickyBar.setAttribute('aria-hidden', 'false');
    }

    function hideSticky() {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
    }

    if (hero && typeof window.IntersectionObserver === 'function') {
      var observer = new window.IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { hideSticky(); } else { showSticky(); }
      }, { threshold: 0 });
      observer.observe(hero);
      return;
    }

    // Scroll-listener fallback
    var rafPending = false;
    function checkScrollPosition() {
      rafPending = false;
      if (!isMobile()) { hideSticky(); return; }
      if (!hero) { showSticky(); return; }
      var rect = hero.getBoundingClientRect();
      if (rect.top + rect.height <= 0) { showSticky(); } else { hideSticky(); }
    }
    function onScroll() {
      if (!rafPending) {
        rafPending = true;
        window.requestAnimationFrame(checkScrollPosition);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    checkScrollPosition();
  }
};

document.addEventListener('DOMContentLoaded', function () {
  window.ewStageRouter.init();
});
